module.exports = __webpack_public_path__ + "static/img/yk6230.21aa899.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hardware/yk6230.png
// module id = 1QQv
// module chunks = 1